import { useCallback, useState } from 'react';

import { fetchPostSingleImmediatePayment } from '@iwoca/lapi-client/edge';

import { getPayLinkUrl } from '../utils/getPayLinkUrl';
import logger from '../utils/logger';

export const usePayNow = (payLinkId: string | null) => {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const redirectToSelectPaymentProvider = useCallback(async () => {
    if (!payLinkId) {
      setError(
        'Unable to establish pay link, please try use the original url received or call us on 020 3778 0274',
      );
      return;
    }

    try {
      setLoading(true);

      const response = await fetchPostSingleImmediatePayment({
        body: { data: { pay_link_id: payLinkId } },
      });

      setLoading(false);
      setError(null);
      window.location.href = response.data!.payment_provider_auth_uri;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      setError('Failed to initiate payment give us a call on 020 3778 0274');
      logger.error('Failed to initiate Pay Now', {
        payLinkUrl: getPayLinkUrl('anonymised-seller-name', payLinkId),
        payLinkId: payLinkId,
        errorMessage: error.message,
      });
    }
  }, [setLoading, setError, payLinkId]);

  return {
    error,
    loading,
    redirectToSelectPaymentProvider,
  };
};
